import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  statusType: {
    display: 'block',
    width: 100,
  },
  amountStack: {
    fontWeight: 'bold',
    marginLeft: 0,
    display: 'block',
  },
  logo: {
    fill: theme.palette.neutralPrimary,
  },
  cellContainer: {
    height: 25,
  },
 
}));
